<template>
  <div class="header gap-5 border-b-2 mb-2 pr-10 border-classen__secondary 3k:text-4xl">
    <div class="w-8/10 h-9/10 text-right">
      <div v-if="$route.name === 'Selection'" class="flex justify-end" @click="reloadPage()">
          <img class="w-8/10" src="../../assets/media/classen_logo.jpg" alt="classen logo"/>
      </div>
      <router-link v-else to="/products" class="flex justify-end">
        <img class="w-8/10" src="../../assets/media/classen_logo.jpg" alt="classen logo"/>
      </router-link>
    </div>

    <div v-if="loggedIn"
         class="nav-container text-lg uppercase 4k:text-3xl grid grid-rows-2 grid-cols-12 5xl:grid-cols-8 1.5xl:grid-rows-1 items-center">
      <router-link class="col-span-5 1.5xl:col-span-3" to="/products"
                   v-if="canSeeNav() && !canNotSeeProducts">
        {{ getTranslation('articles') + '/' + getTranslation('decors') + '/' + getTranslation('packaging') }}
      </router-link>
      <router-link class="col-span-2 col-start-7 1.5xl:col-span-1" to="/selections"
                   v-if="canSeeNav() && canSeeSelections">
        {{ getTranslation('selections') }}
      </router-link>
      <!--Todo: Re-enable-->
      <router-link class="col-span-2 1.5xl:col-span-1" to="" v-if="false && canSeeNav()">
        {{ getTranslation('marketing') }}
      </router-link>

      <div v-if="canSeeConfiguration()" v-click-outside="lostFocusConfiguration"
           class="col-span-3 col-start-0 row-start-2 col-span-5 1.5xl:col-span-2 1.5xl:row-start-1 1.5xl:col-start-9 dropdown text-center cursor-pointer"
           :class="{'displayed':configurationToggleIsOpen}">
        <div @click="toggleOpenConfiguration" class="title">
          {{ getTranslation('configuration') }}
          <i class="fas fa-angle-down"></i>
        </div>
        <div @onfocusout="lostFocusConfiguration" class="dropdown-content border-t-2 border-classen__primary">
          <div v-if="configurationToggleIsOpen && canSeeUsers()" @click="configurationToggleIsOpen = false">
            <router-link class="w-full h-full" to="/users">{{
                getTranslation('users')
              }}
            </router-link>
          </div>
          <div v-if="configurationToggleIsOpen && canSeeTranslations()" @click="configurationToggleIsOpen = false">
            <router-link class="w-full h-full" to="/translations">{{
                getTranslation('translations')
              }}
            </router-link>
          </div>
        </div>
      </div>

        <div v-click-outside="lostFocusUser"
             class="col-span-2 col-start-7 row-start-2 col-span-2 1.5xl:col-span-2 1.5xl:row-start-1 1.5xl:col-start-11 activeUser relative"
             :class="{'displayed':userToggleIsOpen}">
            <div @click="toggleOpenUser" class="flex items-center justify-center">
                <p class="title truncate mr-1">{{ activeUser.name }}</p>
                <i class="fas fa-angle-down"></i>
            </div>
            <div @onfocusout="lostFocusUser" class="dropdown-content border-t-2 border-classen__primary">
                <div v-if="userToggleIsOpen" @click="userToggleIsOpen = false">
                    <div @click="signOut" class="w-full h-full">
                        {{ getTranslation('logout') }}
                    </div>
                </div>
                <div v-if="userToggleIsOpen" @click="userToggleIsOpen = false">
                    <div class="w-full h-full" @click="showProfilePopup = true">
                        {{ getTranslation('profile') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="py-6 col-start-3 4k:text-3xl">
      <select class="h-full pl-10 border-classen__secondary border-l-2 focus:outline-none"
              v-model="selectedLanguage">
        <option v-for="language in languages" :value="language.id">
          {{ getTranslation(language.code) }}
        </option>
      </select>
    </div>

    <c-profile-popup v-if="showProfilePopup" @cancel="showProfilePopup = false"></c-profile-popup>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import EventBus from '../../services/EventBus';
import getTranslation from "../../mixins/getTranslation";
import Select from "../Select";
import getPermissions from "../../mixins/getPermissions";
import ProfilePopup from "./ProfilePopup";

export default {
  name: 'Header',

  components: {
    Select,
    'c-profile-popup': ProfilePopup
  },

  data() {
    return {
      selectedLanguage: 1,
      configurationToggleIsOpen: false,
      userToggleIsOpen: false,
      showProfilePopup: false,
    }
  },

  watch: {
    activeUser: function () {
      this.checkLoggedIn();
    },

    selectedLanguage() {
      this.$dashboardStore.commit('SET_LANGUAGE', this.selectedLanguage)
    }
  },

  mixins: [getTranslation, getPermissions],

  computed: {
    languages() {
      return this.$dashboardStore.getters.getLanguages.filter((language) => language.isActive);
    },

    activeUser() {
      return this.$dashboardStore.getters.getActiveUser();
    },

    loggedIn() {
      let path = this.$route.path;
      return path.split('/')[1] !== 'selection'
    }
  },

  created() {
    if (this.canNotSeeProducts) {
      this.$router.push({path: '/selections'})
    }

    this.checkLoggedIn();

    EventBus.listen('close-nav', this.closeNav);
  },

  destroyed() {
    EventBus.destroy('close-nav', this.closeNav);
  },

  methods: {
    lostFocusConfiguration() {
      this.configurationToggleIsOpen = false;
    },

    lostFocusUser() {
      this.userToggleIsOpen = false;
    },

    closeNav() {
      this.configurationToggleIsOpen = false;
      this.userToggleIsOpen = false;
    },

    signOut() {
      this.$dashboardStore.dispatch('clearAuthUser');
      EventBus.fire('signed-out-user');
    },

    checkLoggedIn() {
      if (this.$route.name === 'Selection') {
        return
      }

      if (!this.activeUser) {
        this.$router.push({path: '/login'})
      }

      this.selectedLanguage = this.activeUser.languageId;
      this.$dashboardStore.commit('SET_LANGUAGE', this.selectedLanguage);
    },

    toggleOpenConfiguration() {
      this.configurationToggleIsOpen = !this.configurationToggleIsOpen;
      EventBus.fire('close-selection');
      EventBus.fire('close-menus');
    },

    toggleOpenUser() {
     this.userToggleIsOpen = !this.userToggleIsOpen;
     EventBus.fire('close-selection');
     EventBus.fire('close-menus');
    },

    close() {
      this.configurationToggleIsOpen = false;
    },
  },

  directives: {
    ClickOutside
  }
};
</script>
<style scoped>
.header {
  display: grid;
  grid-template-columns: 23% 67% 10%;
  align-content: center;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #FFFFFF;
  width: 100%;
  height: fit-content;
  padding: 12px 16px;
  z-index: 1;
  box-shadow: 0 0 2px 2px rgba(234, 235, 236, 0.71);
}

.displayed .dropdown-content {
  display: block;
}
</style>
